import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import SettingTabMaintenanceScheduleOwner from 'Lots/Components/Maintenance/tip-list';
import SpecificTabMaintenanceScheduleOwner from 'Lots/Components/Maintenance/reminder-list';

export class HomeMaintenance extends Component {
    static propTypes = {
      projectId: PropTypes.string,
      lot: PropTypes.object
    };

    constructor(props) {
      super(props);
      this.state = {
        tabMode: 'specific'
      };
    }

    onSwitchTab = (type) => {
      this.setState({
        tabMode: type
      });
    }

    renderTabFunctionButton = () => {
      const {tabMode} = this.state;
      return (
        <div className='tab-function-maintenance-schedule row'>
          <button onClick={() => this.onSwitchTab('specific')} className={tabMode === 'specific' ? 'radius-button-maintenance btn bn-primary btn-siteone' : 'radius-button-maintenance btn btn-siteone-default'}>Specific maintenance schedule by date</button>
          <button onClick={() => this.onSwitchTab('settings')} className={tabMode === 'settings' ? 'radius-button-maintenance btn bn-primary btn-siteone' : 'radius-button-maintenance btn btn-siteone-default'}>Maintenance tips not attached to time</button>
        </div>
      );
    }

    renderTabModeSelection = () => {
      const {tabMode} = this.state;
      return (
        <React.Fragment>
          {
            tabMode === 'settings' && <SettingTabMaintenanceScheduleOwner />
          }
          {
            tabMode === 'specific' && <SpecificTabMaintenanceScheduleOwner lot={this.props.lot} />
          }
        </React.Fragment>
      );
    }
    render() {
      return (
        <div className='maintenance-schedule-wrapper'>
          {/* <div className='container-fluid'>
            {this.renderTabFunctionButton()}
          </div> */}
          {this.renderTabModeSelection()}

        </div>
      );
    }
}

const mapStateToProps = () => {
  return {

  };
};

export default withRouter(connect(mapStateToProps)(HomeMaintenance));



// WEBPACK FOOTER //
// ./src/Lots/Containers/home-hub-home-maintenance.js